export default "__VITE_ASSET__CGxNUh5H__"